/* Load once in theme.liquid. The optional explicit anchor is documented in README-HU.md. */
(() => {
  if (window.veloraCharmReturnLoaded) return;
  window.veloraCharmReturnLoaded = true;
  function init() {
    document.querySelector('.velora-return-link')?.remove();
    if (!/\/products\/[^/]+/.test(location.pathname)) return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem('velora:return:v1') || 'null'); } catch (_) { return; }
    if (!saved || Date.now() - saved.time > 86400000) return;
    let url;
    try { url = new URL(saved.url, location.origin); } catch (_) { return; }
    if (url.origin !== location.origin || !/\/products\/[^/]+/.test(url.pathname) || url.pathname === location.pathname) return;
    // Csak azon a charm-oldalon jelenjen meg, amelyet a választóból nyitottak meg (más termékoldalon nem).
    const current = decodeURIComponent(location.pathname.split('/products/')[1] || '').replace(/\/$/, '');
    if (!saved.detail || current !== saved.detail) return;
    const anchor = document.querySelector('[data-velora-return-anchor]') || document.querySelector('main');
    if (!anchor) return;
    const link = document.createElement('a'); link.href = url.href; link.className = 'velora-return-link';
    link.textContent = '← Vissza az összeállításomhoz';
    // Inline essentials also work on charm templates without the builder stylesheet.
    link.style.cssText = 'display:block;padding:12px 20px;color:inherit;text-decoration:underline;text-underline-offset:3px';
    anchor.prepend(link);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  window.addEventListener('pageshow', init);
})();
